require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./has-done-been-up-to-a-lot.json") })
        }
      }, "path---has-done-been-up-to-a-lot");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---has-done-been-up-to-a-lot!./.cache/json/has-done-been-up-to-a-lot.json
// module id = 521
// module chunks = 231608221292675